import React from 'react';
import {Box, Stack, Typography} from '@mui/material';
import './SingleQuestion.scss';
import {QALabel} from '../QALabel';
import ArrIconButton from '../../../../../common/arr-icon-button/ArrIconButton';
import ArrTooltip from '../../../../../common/arr-tooltip/ArrTooltip';
import {ReactComponent as DeleteIcon} from '../../../../../../assets/images/delete-chat.svg';
import dayjs from 'dayjs';
import {t} from 'i18next';
import {ConversationDto} from '../../InvestigateChatPanel';

interface ISingleQuestion {
  question: ConversationDto;
  readOnly?: boolean;
  ownerName?: string;
  isRemovable?: boolean;
  handleRemove?: () => void;
}

const SingleQuestion = ({
  question,
  readOnly = false,
  ownerName = '',
  isRemovable = false,
  handleRemove,
}: ISingleQuestion) => {
  const formattedDate = dayjs
    .utc(question.createDate)
    .format('YYYY/MM/DD hh:mmA [UTC]');
  return (
    <Box
      className={`question-space ${readOnly ? 'question-space-others' : ''}`}
      key={question.conversationId}
    >
      <Box
        className="question-container"
        data-testid={`single-question-${question.conversationNumber}`}
        tabIndex={0}
        role="question"
        aria-label={`Question ${question.conversationNumber}`}
      >
        <QALabel label={`Q${question.conversationNumber}`} />

        <Typography
          className={`typo-text body3_size ${question?.isRemoved && 'removed-prompt'}`}
          tabIndex={0}
          data-testid={`single-question-asked-${question.conversationNumber}`}
        >
          {question?.isRemoved
            ? t('ai.investigate.question.removed')
            : question.question}
        </Typography>
        {!question?.isRemoved && (
          <Box flexDirection={'row'} className="q-action-date">
            <Stack className="question-actions">
              {isRemovable && (
                <ArrTooltip
                  content={t('ai.investigate.question.remove.tooltip')}
                  placement="top"
                  labelId={`remove-tooltip`}
                >
                  <ArrIconButton
                    icon={<DeleteIcon />}
                    onClick={handleRemove}
                    ariaLabel={t('ai.investigate.question.remove.altText', {
                      number: question.conversationNumber,
                    })}
                    shape="none"
                    size="small"
                    className="question-remove-icon-button"
                    testId="remove-icon"
                  />
                </ArrTooltip>
              )}
            </Stack>
            <Typography
              className="typo-text body4_size text-body-subtle"
              data-testid={`question-asked-date-${question.conversationNumber}`}
              tabIndex={0}
            >
              {readOnly && ownerName} {formattedDate}
            </Typography>
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default SingleQuestion;
